import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_AUFGABE_AKTUALISIEREN = '[VeranstaltungenModul] PostAufgabeAktualisieren laden';
export const POST_AUFGABE_AKTUALISIEREN_AUSFUEHREN = '[VeranstaltungenModul] PostAufgabeAktualisieren ausführen';
export const POST_AUFGABE_AKTUALISIEREN_ERFOLGREICH = '[VeranstaltungenModul] PostAufgabeAktualisieren laden erfolgreich';
export const POST_AUFGABE_AKTUALISIEREN_FEHLER = '[VeranstaltungenModul] PostAufgabeAktualisieren Ladefehler';
export const POST_AUFGABE_AKTUALISIEREN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostAufgabeAktualisieren nicht ausgeführt (evtl. Offline)';


export class PostAufgabeAktualisierenAction implements Action {
    readonly type = POST_AUFGABE_AKTUALISIEREN;
        constructor(public aufgabeAnlegenRequest: api.AufgabeAnlegenRequest, public optPayload: any = null) {}
    }
export class PostAufgabeAktualisierenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABE_AKTUALISIEREN_AUSFUEHREN;
        constructor(public aufgabeAnlegenRequest: api.AufgabeAnlegenRequest, public optPayload: any = null) {}
    }
export class PostAufgabeAktualisierenErfolgreichAction implements Action {
    readonly type = POST_AUFGABE_AKTUALISIEREN_ERFOLGREICH;
        constructor(public payload: api.AufgabeIdentifier, public aufgabeAnlegenRequest: api.AufgabeAnlegenRequest, public optPayload: any = null) {}
    }
export class PostAufgabeAktualisierenFehlerAction implements Action {
    readonly type = POST_AUFGABE_AKTUALISIEREN_FEHLER;
        constructor(public payload: any, public aufgabeAnlegenRequest: api.AufgabeAnlegenRequest, public optPayload: any = null) {}
    }
export class PostAufgabeAktualisierenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABE_AKTUALISIEREN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandAufgabeAktualisierenActions =
    PostAufgabeAktualisierenAction
    | PostAufgabeAktualisierenAusfuehrenAction
    | PostAufgabeAktualisierenErfolgreichAction
    | PostAufgabeAktualisierenFehlerAction
    | PostAufgabeAktualisierenNichtAusgefuehrtAction
    ;
